import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import policy from './policy';
import { useDispatch, useSelector } from 'react-redux';

import { createAccountAgreeRequest } from '../../../../redux_modules/agree';
import { RootState } from '../../../../redux_modules';
const Wrap = styled.div`
  > div {
    display: flex;
    align-items: center;
    padding: 1.25rem;
    border-bottom: 1px solid #e0e5e9;
    cursor: pointer;

    :first-child {
      background-color: #f7f7f7;
      > p {
        font-weight: bold;
      }
    }

    > p {
      font-size: 1rem;
      padding-left: 1.25rem;
      > span {
        font-size: 0.77rem;
        padding-left: 1.25rem;
        text-decoration: underline;
      }
    }
  }
`;

const SpanImg = styled.span<{ selected: boolean }>`
  width: 28px;
  height: 28px;
  background: url('/images/btnRegister.png') left ${(props) => (props.selected ? 'bottom' : 'top')} no-repeat;
`;

function AgreeWrap() {
  const [allAgree, setAllAgree] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);

  const dispatch = useDispatch();

  const { agreeInfo } = useSelector((state: RootState) => ({
    agreeInfo: state.agreeInfo,
  }));

  useEffect(() => {
    if (allAgree === true || (agree1 === true && agree2 === true)) {
      if (agreeInfo.status !== 'SUCCESS') {
        dispatch(createAccountAgreeRequest(true));
      }
    } else {
      if (agreeInfo.status === 'SUCCESS') {
        dispatch(createAccountAgreeRequest(false));
      }
    }
  }, [allAgree, agree1, agree2]);

  // 약관 팝업 노출
  const policyOpen = async (policyType: 'combine' | 'private') => {
    const confirm = await Swal.fire({
      customClass: {
        popup: 'swal-custom-popup',
        header: 'swal-custom-header',
        title: 'swal-custom-title',
        content: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirmButton',
        cancelButton: 'swal-custom-cancleBtn',
      },
      title: policy[policyType].title,
      html: policy[policyType].html,
      confirmButtonText: '확인',
      width: 840,
    });
    if (confirm.isConfirmed && policyType === 'combine') {
      setAgree1(true);
    }
    if (confirm.isConfirmed && policyType === 'private') {
      setAgree2(true);
    }
  };

  return (
    <Wrap>
      <div
        onClick={() => {
          const targetBoolean = !allAgree;

          setAllAgree(targetBoolean);
          setAgree1(targetBoolean);
          setAgree2(targetBoolean);
        }}
      >
        <SpanImg selected={allAgree} />
        <p>이용약관에 모두 동의합니다.</p>
      </div>
      <div
        onClick={(e) => {
          const target: any = e.target;

          if (target.tagName === 'SPAN') {
            policyOpen('combine');
          } else {
            setAgree1(!agree1);
          }
        }}
      >
        <SpanImg selected={agree1} />
        <p>
          PLAYAUTO 통합회원 이용약관(필수)
          <span>약관보기</span>
        </p>
      </div>
      <div
        onClick={(e) => {
          const target: any = e.target;

          if (target.tagName === 'SPAN') {
            policyOpen('private');
          } else {
            setAgree2(!agree2);
          }
        }}
      >
        <SpanImg selected={agree2} />
        <p>
          개인정보 취급방침(필수)
          <span>약관보기</span>
        </p>
      </div>
    </Wrap>
  );
}

export default AgreeWrap;
